// extracted by mini-css-extract-plugin
module.exports = {"moveEntityButton":"styles_moveEntityButton__Ngkyj","moveEntityWrapper":"styles_moveEntityWrapper__13A9h"};